export const FURROW_REQUEST = "FURROW_REQUEST";
export const FURROW_SUCCESS = "FURROW_SUCCESS";
export const FURROW_FAILED = "FURROW_FAILED";
